<template>
  <div>
    <DarkModeSwitcher />
    <div class="container sm:px-10 mx-auto">
      <div class="block xl:grid grid-cols-2 gap-4">
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href class="-intro-x flex items-center pt-5">
            <img alt="FINSOS" src="./../../assets/images/finsos-logo.png" class="w-12" />
            <span class="text-white text-lg ml-3">
              <span class="font-medium">FINSOS</span>
            </span>
          </a>
          <div class="my-auto">
            <img
              alt="FINSOS"
              src="./../../assets/images/illustration.svg"
              class="-intro-x w-1/2 -mt-16"
            />
            <div class="-intro-x text-white font-medium text-4xl leading-tight mt-10">
              {{ $t('auth.text1') }}
              <br />
              {{ $t('auth.text2') }}
            </div>
            <div class="-intro-x mt-5 text-lg text-white dark:text-gray-500">
              {{ $t('auth.text3') }}
            </div>
          </div>
        </div>
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DarkModeSwitcher from '@/components/ui/DarkModeSwitcher';

export default {
  components: { DarkModeSwitcher },
  mounted() {
    document.querySelector('body').classList.add('login');
  },
};
</script>
